export default __webpack_public_path__ + "static/media/illustration-recruit-2-w.51c20a84.webp";